import { ReactNode } from "react";

interface IconLabellableProps {
  icon: ReactNode;
  text?: string;
  children?: ReactNode;
  className?: string;
  align?: "center" | "start";
}

export default function IconLabelable({
  icon,
  text,
  children,
  className = "",
}: IconLabellableProps) {

  return (
    <div className={`flex items-baseline mt-1 space-x-2 lg:space-x-4 ${className}`}>
      <div className="size-5 text-darkred lg:size-6 shrink-0 relative top-1">
        {icon}
      </div>
      {children || <p className="whitespace-nowrap inline my-0">{text}</p>}
    </div>
  );
}
